
export const environment = {
  production: true,

  //Define all url
  apiUrl: 'https://api.barmitierra.com/api',
  baseUrl: 'https://api.barmitierra.com',
  baseLoginUrl: 'https://api.barmitierra.com/api',

  //Fet default category
  mainCategory: '0',
  lang: 'es',
  client: 'barmitierra',
  logo: 'assets/barmitierra/logo.svg',
  appName: 'Bar Mi Tierra',
  menuPdf: true,


  availableLanguages: ['es', 'en', 'fr', 'de', 'nl', 'pt', 'it', 'pl', 'bg', 'cz'],
  isBelgium: false,
  info: true,
  componentLoading: "app-barmitierra-splashscreen",

  firebaseConfig: {
    apiKey: "AIzaSyBywvtRRUN93jzwfIfDAqNkrHlcXeTk6CA",
    authDomain: "bar-mi-tierra.firebaseapp.com",
    projectId: "bar-mi-tierra",
    storageBucket: "bar-mi-tierra.firebasestorage.app",
    messagingSenderId: "585114975583",
    appId: "1:585114975583:web:8c7ff970dc6d808bf60aea",
    measurementId: "G-111Z56DBM4"
  }

};
